// Modules
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

// Rxjs
import { Observable } from 'rxjs';

// Services
import { AppConfigService } from '@shared-module/services/app-config/app-config.service';

@Injectable({ providedIn: 'root' })
export class ForcedPasswordChangeService {
  private get _baseUrl(): string {
    return `${this._app.authBaseUrl}/auth`;
  }

  constructor(
    private _http: HttpClient,
    private _app: AppConfigService
  ) {}

  // POST /auth/complete-forced-change
  // Body: { passwordChangeChallengeId: string, newPassword: string }
  // Response: LoginResponseDto (same as normal login)
  changePassword(challengeId: string, newPassword: string): Observable<any> {
    return this._http.post<any>(`${this._baseUrl}/complete-forced-change`, {
      passwordChangeChallengeId: challengeId,
      newPassword,
    });
  }
}
